exports.isAPIError = err => err && err.response && err.response.data && err.response.data.statusCode;